import { useNavigate } from "react-router-dom";
 
function withNavigation(Component) {
  return props => <Component {...props} navigate={useNavigate()} />;
}
 
export default withNavigation